import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import PageHeader from '../../components/PageHeader';
import PeriodCostBanner from '../../components/PeriodCostBanner';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { periodPropTypes } from '../../reducers/propTypes';
import { periodSelector, periodsPerClassIdSelector } from '../../reducers/selectors';

const LoanContextPage = ({ periods, period, dispatchWizardNav, dispatchAddPageData }) => {
  const { periodGuid, periodOrder: currentPeriodOrder, costOfAttendance, costOfTuition } = period;
  let previousCostOfAttendance = 0;
  let previousCostOfTuition = 0;
  let remainderCostOfAttendance = 0;
  let remainderCostOfTuition = 0;
  let totalCostOfAttendance = 0;
  let totalCostOfTuition = 0;

  periods.forEach(p => {
    totalCostOfAttendance += p.costOfAttendance;
    totalCostOfTuition += p.costOfTuition;

    if (p.periodOrder < currentPeriodOrder) {
      previousCostOfAttendance += p.costOfAttendance;
      previousCostOfTuition += p.costOfTuition;
    }

    if (p.periodOrder > currentPeriodOrder) {
      remainderCostOfAttendance += p.costOfAttendance;
      remainderCostOfTuition += p.costOfTuition;
    }
  });

  const handleSubmit = event => {
    event.preventDefault();

    analytics.sendEvent('Click - Next', 'loan-context');

    const previousCostOfTuitionPayload = payloadFactory.createAddPageDataPayload(
      'previousCostOfTuition',
      previousCostOfTuition,
    );

    const previousCostOfAttendancePayload = payloadFactory.createAddPageDataPayload(
      'previousCostOfAttendance',
      previousCostOfAttendance,
    );

    const periodCostOfTuitionPayload = payloadFactory.createAddPageDataPayload(
      'periodCostOfTuition',
      costOfTuition,
    );

    const periodCostOfAttendancePayload = payloadFactory.createAddPageDataPayload(
      'periodCostOfAttendance',
      costOfAttendance,
    );

    const remainderCostOfTuitionPayload = payloadFactory.createAddPageDataPayload(
      'remainderCostOfTuition',
      remainderCostOfTuition,
    );

    const remainderCostOfAttendancePayload = payloadFactory.createAddPageDataPayload(
      'remainderCostOfAttendance',
      remainderCostOfAttendance,
    );

    const totalCostOfTuitionPayload = payloadFactory.createAddPageDataPayload(
      'totalCostOfTuition',
      totalCostOfTuition,
    );

    const totalCostOfAttendancePayload = payloadFactory.createAddPageDataPayload(
      'totalCostOfAttendance',
      totalCostOfAttendance,
    );

    dispatchAddPageData(previousCostOfTuitionPayload);
    dispatchAddPageData(previousCostOfAttendancePayload);
    dispatchAddPageData(periodCostOfTuitionPayload);
    dispatchAddPageData(periodCostOfAttendancePayload);
    dispatchAddPageData(remainderCostOfTuitionPayload);
    dispatchAddPageData(remainderCostOfAttendancePayload);
    dispatchAddPageData(totalCostOfTuitionPayload);
    dispatchAddPageData(totalCostOfAttendancePayload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  return (
    <>
      <PeriodCostBanner periods={periods} currentPeriod={periodGuid} />
      <form className="container container--space-y" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col col--12/16-large">
            <PageHeader
              title="How we issue our loans"
              action={() => dispatchWizardNav({ dir: 'back' })}
            />
            <p>
              To make sure you get the right amount, at the right time we issue one loan for each of
              your study periods. A study period could be a term, semester or year - depending on
              your course.
            </p>
            <h2>What does that mean for you?</h2>
            <ul>
              <li>
                The offer you get from this application will only be for your upcoming studying
                period. That means you won&apos;t pay interest on money you aren&apos;t using.
              </li>
              <li>
                We&apos;ll also let you know what you&apos;re eligible to borrow for the remainder
                of your course. Don&apos;t worry, we&apos;ll notify you when it&apos;s time to come
                back and secure a loan for your next study period.
              </li>
            </ul>
          </div>
        </div>
        <div className="row-spacer">
          <Button type="submit">Next</Button>
        </div>
      </form>
    </>
  );
};

LoanContextPage.propTypes = {
  periods: PropTypes.arrayOf(periodPropTypes).isRequired,
  period: periodPropTypes.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
  dispatchAddPageData: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  periods: periodsPerClassIdSelector(state),
  period: periodSelector(state),
});

const mapDispatchToProps = {
  dispatchWizardNav: navigateWizard,
  dispatchAddPageData: addPageData,
};

export { LoanContextPage, mapDispatchToProps };

export default connect(mapStateToProps, mapDispatchToProps)(LoanContextPage);
